import React, { useEffect, useState } from "react";
import { adminSelectors, useSelector } from "../../../state";
import { CoverageSection } from "./CoverageSection";

const CoverageWrapper = ({
  payFrequency,
}: {
  payFrequency: "installments" | "full";
}) => {
  const { quotes, applicant } = useSelector(adminSelectors.activeQuote);
  const [selectedQuote, setSelectedQuote] = useState<any>();
  const [hasPurchased, setHasPurchased] = useState<any>();

  const getPremium = (quote) => {
    if (!Array.isArray(quote.response_payload)) return;
    const quoteHasPremium = quote?.response_payload?.find(
      (quote) => !!quote.PayPlanDescription,
    );
    if (!quoteHasPremium) return 0;
    if (payFrequency === "installments") {
      const installements = quote?.response_payload?.find(
        (quote) => !quote.PayPlanDescription.includes("Full"),
      );
      if (installements) {
        return installements.TotalPremium;
      }
    } else {
      const paidInFull =
        quote?.response_payload?.find((quote) =>
          quote.PayPlanDescription.includes("Full"),
        ) ||
        (quote?.quote_type === "home" &&
          quote?.response_payload?.find((quote) =>
            quote.PayPlanDescription.includes("MetLife Payment Option"),
          ));
      if (paidInFull) {
        return paidInFull.TotalPremium;
      }
    }
    return 0;
  };
  useEffect(() => {
    setHasPurchased(false);
    setSelectedQuote(null);
    (async () => {
      [1, 2, 3, 0].map(async (level) => {
        const quotesByLevel = Object(quotes[`${level}`]);
        if (Array.isArray(quotesByLevel) && quotesByLevel.length) {
          //find and set selected quote
          const _selectedQuote = quotesByLevel.find(
            (q) =>
              (q.req_txn_id === applicant.selected_quote_auto ||
                q.req_txn_id === applicant.selected_quote_home) &&
              getPremium(q) > 0,
          );
          const purchasedQuote = quotesByLevel.find(
            (q) => q.full_premium_override,
          );

          if (purchasedQuote) {
            setHasPurchased(true);
          }
          if (_selectedQuote) {
            await setSelectedQuote(_selectedQuote);
          }
        }
      });
    })();
  }, [quotes, payFrequency]);

  const coverages = [1, 2, 3, 0].map((level) => {
    const quotesByLevel = Object(quotes[`${level}`]);
    if (Array.isArray(quotesByLevel) && quotesByLevel.length) {
      const _quotes = quotesByLevel.map((q) => {
        return { ...q, displayPremium: getPremium(q) };
      });
      //filter and sort quotes - selected and then price low to high
      const purchasedQuote = _quotes.find((q) => q.full_premium_override > 0);

      const filteredQuotes = purchasedQuote
        ? _quotes?.filter((q) => q.full_premium_override === null)
        : _quotes?.filter(
            (quote) => quote.req_txn_id !== selectedQuote?.req_txn_id,
          );

      const categorized = filteredQuotes.reduce(
        (acc, curr) => {
          const succeeded = curr.displayPremium > 0 && curr.total_premium > 0;
          const notAvailable =
            curr.displayPremium === 0 && curr.total_premium > 0;
          const failed =
            curr.displayPremium === 0 && curr.total_premium === "0.00";
          const errored = curr.request_status === "failed";
          if (succeeded) {
            acc.succeeded?.push(curr);
          }
          if (notAvailable) {
            acc.notAvailable?.push(curr);
          }
          if (failed) {
            acc.failed?.push(curr);
          }
          if (errored) {
            acc.errored?.push(curr);
          }
          return acc;
        },
        { succeeded: [], notAvailable: [], failed: [], errored: [] },
      );

      const sortedQuotes = categorized.succeeded
        .sort(function (a, b) {
          return a.displayPremium - b.displayPremium;
        })
        .concat(categorized.notAvailable)
        .concat(categorized.failed)
        .concat(categorized.errored);

      const _selectedQuote = _quotes.find(
        (q) =>
          q.displayPremium > 0 && q.req_txn_id === selectedQuote?.req_txn_id,
      );

      const displayQuotes = purchasedQuote
        ? [purchasedQuote, ...sortedQuotes]
        : _selectedQuote
        ? [_selectedQuote, ...sortedQuotes]
        : sortedQuotes;

      if (displayQuotes.length) {
        return (
          <div key={level}>
            <CoverageSection
              quotes={displayQuotes}
              level={level}
              selectedQuote={selectedQuote}
              hasPurchased={hasPurchased}
            />
          </div>
        );
      }
    }
    return <div key={level}></div>;
  });

  return <>{coverages}</>;
};

export default React.memo(CoverageWrapper);
